/* eslint-disable react-hooks/exhaustive-deps */
import {CSSProperties, Dispatch, SetStateAction, useEffect} from 'react'
import {KTIcon, useDebounce} from '../../../../_metronic/helpers'

export type InputSearchBoxProps = {
  searchTerm: string
  setSearchTerm: Dispatch<SetStateAction<string>>
  searchDelay?: number
  placeholder?: string
  widthClass?: string
  style?: CSSProperties
}

const InputSearchBox = ({
  searchDelay = 200,
  placeholder = 'Enter search value',
  searchTerm,
  setSearchTerm,
  widthClass = 'w-350px w-md-500px',
  style,
}: InputSearchBoxProps) => {
  const debouncedSearchTerm = useDebounce(searchTerm, searchDelay)

  useEffect(
    () => {
      if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
        setSearchTerm(debouncedSearchTerm)
      }
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
    // More details about useDebounce: https://usehooks.com/useDebounce/
  )

  return (
    <div className={`d-flex align-items-center position-relative my-2 ${widthClass}`} style={style}>
      <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6 text-gray-700' />
      <input
        type='text'
        className='form-control form-control-solid ps-16 rounded-pill py-3 bg-transparent border border-gray-600'
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  )
}

export default InputSearchBox
